import replaceExtractedAlias from "./replace-extracted-alias";

/**
 * Replace the alias string
 * @param {Array<String>} aliases
 * @param {String} attribute
 * @returns {AliasProcessingProps}
 */
const getReplacedAliasString = (aliases, attribute) => {
  let result = new Map();

  /** Loop trough all matches aliases associated with an attribute */
  for (const item of aliases) {
    /**
     * Alias ref for the TypeScript
     * @type {AliasVariantsProps}
     */
    const alias = /** @type {AliasVariantsProps} */ (item);

    /** Search for whole alias */
    const regex = new RegExp(`\\b(${alias})\\s*\\((?:[^()]*|\\([^()]*\\))*\\)`);

    /** Extract the whole alias with parenthesis */
    const extracted = regex.exec(attribute);

    if (extracted) {
      result = replaceExtractedAlias(alias, attribute, extracted[0], result);
    }
  }

  return result;
};

export default getReplacedAliasString;
